<script setup>
import CrossIcon from "~/components/icons/CrossIcon.vue";
import {GoogleMap, Marker, InfoWindow} from 'vue3-google-map'
import Heading from "~/components/atoms/Heading.vue";
import Button from "~/components/atoms/Button.vue";
import Radiobox from "~/components/atoms/Radiobox.vue";
import {useCartStore} from "~/store/cartStore.js";

const store = useCartStore();
const props = defineProps(['countries', 'serviceLocations', 'currentServiceLocation'])
</script>

<template>
  <div class="row full-width flexed flex-start g-24 column-mobile" style="height: 100%;">
    <div class="map full-width" style="height: 100%;" v-if="currentServiceLocation">
      <GoogleMap
          :center="{lat: currentServiceLocation.latitude, lng: currentServiceLocation.longitude}"
          api-key="AIzaSyDxmYiW7uSdESdBmrMUa4d4IxW8L3SwzLs"
          style="width: 100%; height: 100%"
          :fullscreenControl="true"
          :mapTypeId="'roadmap'"
          :streetViewControl="true"
          :scaleControl="true"
          :rotateControl="true"
          :zoom="20">
        <Marker v-for="point in serviceLocations"
                @click="store.saveServicePoint(point)"
                :options="{ position: {lat: point.latitude,lng: point.longitude}}"/>
      </GoogleMap>
    </div>
    <div class="service-point-info full-width" style="position: static">
      <div class="header row full-width space-between" style="position: static">
        <Heading tag="h3">{{ $t('checkout.choose_service_point') }}</Heading>

        <div @click="$emit('close')" class="no-flex clickable close">
          <CrossIcon/>
        </div>
      </div>
      <div class="service-point-info-scroll">
        <div class="service-points">
          <div class="service-point row full-width clickable" @click="store.saveServicePoint(serviceLocation)"
               v-for="serviceLocation in serviceLocations">
            <div class="radio-item control row" style="gap: 15px;">
              <div class="no-flex">
                <Radiobox :model-value="currentServiceLocation?.id"
                          :value="serviceLocation.id"
                          type="radio" name="service-point"/>
              </div>
              <div>
                <Heading tag="h5">{{ serviceLocation.name }}</Heading>
                <p>{{ serviceLocation.cityName }}, {{ serviceLocation.street }}</p>
              </div>
            </div>
          </div>

          <Button v-if="!$device.isDesktop" type="black tall full-width" @click="$emit('close')">{{ $t('base.confirm') }}</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.body {
  justify-content: flex-start;
  flex: 1;
}

.service-point-info-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: 24px;

  @include smd {
    padding-bottom: 330px;
  }
}

.service-point-info {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 24px;
  background: $white;

  @include smd {
    padding: 16px;
  }
}

.service-point {
  padding: 16px 8px;
  border-top: 1px solid #eee;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: #fafafa;
  }
}

.header {
  padding-bottom: 24px;

  &:deep(h3) {
    font-size: 18px;
  }
}


.map:deep(div) {
  //all: unset;
}

.map {
  @include smd {
    min-height: 300px;
  }
}

.close {
  @include smd {
    position: absolute;
    top: 10px;
    right: 10px;
    background: $white;
    padding: 10px;
    border-radius: 100%;
    box-shadow: 0 4px 45px 0 rgba(0, 0, 0, 0.3);
  }
}

button.black {
  @include smd {
    position: fixed;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    border-radius: 25px;
  }
}
</style>
